import { useEffect } from "react";
import styled from "@emotion/styled";

import { BasicFlex } from "../Common";

import { IconButton, Tooltip } from "@mui/material";

import useDraggable from "../../hooks/useDraggable";

import DragIndicatorRoundedIcon from '@mui/icons-material/DragIndicatorRounded';
import RemoveCircleOutlineRoundedIcon from '@mui/icons-material/RemoveCircleOutlineRounded';

const DraggableContainer = styled(BasicFlex)`
  /* padding: 1.6rem; */
`

const Draggable = styled(BasicFlex)`
 width: 100%;
 padding: .8rem;
 border-radius: 5px;
 background-color: ${props => props.theme.colors.darkBg};
`

const DraggableTab = styled.div`

`

const DraggableComponent = ({ useFormik = false, fieldName, list, render, setOrderedList }) => {

  const { items, draggedIndex, handleDragStart, handleDragOver, handleDrop, handleDragEnd, removeItem } = useDraggable({ useFormik, fieldName, field: list });

  useEffect(() => {
    if (setOrderedList) setOrderedList(items)
  }, [items]);

  return (
    <DraggableContainer dir="column" gap="1rem">
      {items?.map((item, index) => (
        <Draggable
          gap=".5rem"
          onDragOver={handleDragOver}
          onDrop={(e) => handleDrop(e, index)}
          draggable 
          onDragStart={(e) => handleDragStart(e, index)}
          onDragEnd={handleDragEnd}
        >
          <DraggableTab
          >
            <IconButton><DragIndicatorRoundedIcon color="basic" fontSize="medium" /></IconButton>
          </DraggableTab>
          {render(item)}
          <Tooltip title="Delete Item"><IconButton onClick={() => removeItem(index)}><RemoveCircleOutlineRoundedIcon color="error" fontSize="medium" /></IconButton></Tooltip>
        </Draggable>
      ))}
    </DraggableContainer>
  )

};

export default DraggableComponent;